module.exports = __webpack_public_path__ + "static/media/chevron_right.5fa3540b.svg";